
import React, { Component, Fragment } from 'react';
import Wrapper from '../../../../common/component/Wrapper';
import { formatMoney } from '../../../../../../helpers/functions';
import { ListComponent, FormWrapperItem } from '../../../../common/component/Index';
import { DATE_TIME_FORMAT } from '../../../../../../constants/Define';
import moment from 'moment';

export default class FnbInfo extends Component {

    render() {
        const { t, fnbs, loading, order } = this.props;

        const columns = [
            {
                title: t('item.order.fnb.restaurant') || 'Nhà hàng',
                dataIndex: 'restaurantName',
                key: 'restaurantName',
            },
            {
                title: t('item.order.fnb.pickupMode') || 'Chế độ nhận hàng',
                dataIndex: 'pickupMode',
                key: 'pickupMode',
            },
            {
                title: t('item.order.fnb.status') || 'Trạng thái đơn hàng',
                dataIndex: 'status',
                key: 'status',
            },
            {
                title: t('item.order.fnb.pickupTime') || 'Thời gian nhận hàng dự kiến',
                dataIndex: 'pickupTime',
                key: 'pickupTime',
                // render: (text) => text ? text.format(DATE_TIME_FORMAT.TIME_DATE) : ''
            },
            {
                title: t('item.order.fnb.bookingCode') || 'Mã booking',
                dataIndex: 'bookingCode',
                key: 'bookingCode',
            },
            {
                title: t('item.order.fnb.orderTime') || 'Thời gian đặt đơn',
                dataIndex: 'orderTime',
                key: 'orderTime',
                render: (text) => <div>{order?.createdDate.format('DD/MM/YYYY HH:mm:ss')}</div>
            },
            {
                title: t('item.order.fnb.dish') || 'Món ăn',
                dataIndex: 'items',
                key: 'items',
                render: (items) => (
                    <div>
                        {(items || []).map((item, idx) => (
                            <div key={idx} style={{ marginBottom: 5 }}>
                                {item.quantity}x {item.name}
                                {item.note && <div style={{ fontSize: '0.8em', color: '#888' }}>{item.note}</div>}
                            </div>
                        ))}
                    </div>
                )
            },
            {
                title: t('item.order.fnb.price') || 'Giá',
                dataIndex: 'items',
                key: 'price',
                render: () => (
                    <div>
                        {formatMoney(order?.subTotal || 0)}
                    </div>
                )
            },
            {
                title: t('item.order.fnb.discount') || 'Giảm giá',
                dataIndex: 'items',
                key: 'discount',
                render: () => (
                    <div>
                        {formatMoney(order?.totalPaymentDiscount || 0)}
                        {/* {(items || []).map((item, idx) => (
                            <div key={idx} style={{ marginBottom: 5 }}>
                                
                            </div>
                        ))} */}
                    </div>
                )
            },
            {
                title: t('item.order.fnb.total') || 'Tổng tiền',
                dataIndex: 'items',
                key: 'total',
                render: () => (
                    <div>
                        {formatMoney(order?.totalPayment || 0)}
                    </div>
                )
            }
        ];

        const dataSource = (fnbs || []).map((fnbItem, index) => ({
            key: index,
            ...(fnbItem.detail || {}),
            items: fnbItem.items || []
        }));

        return (
            <Wrapper className="order-info-section col-md-12 mb-3">
                <h3 className="ml-0">{t('item.order.fnbInfo') || 'Thông tin đơn hàng'}</h3>
                <FormWrapperItem classParent="p-0" classChildren="m-0 p-0">
                    <ListComponent
                        columns={columns}
                        dataSource={dataSource}
                        pagination={false}
                        loading={loading}
                        bordered
                        rowKey="bookingCode"
                        hideSettings={true}
                        scroll={{ x: 4200 }}
                    />
                </FormWrapperItem>
            </Wrapper>
        );
    }
}
